import { useContext, useEffect } from 'react';
import { useChecklistEntry, useChecklists } from '../../hooks/ChecklistHooks';
import { useLogger } from '../../services/LogService';
import { AppContext } from '../../state/AppContextProvider';

export const FetchChecklist = () => {
  const { state } = useContext(AppContext);
  const { isFetch, fetchChecklists } = useChecklists();
  const { getEntry } = useChecklistEntry();

  const logger = useLogger('FetchChecklist');

  useEffect(() => {
    if (isFetch && state.allChecklists.length > 0) {
      state.allChecklists.forEach((checklist, i) => {
        getEntry(checklist);
        logger.info(`Fetched entry for checklist ${checklist.title.rendered}`);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isFetch]);

  useEffect(() => {
    fetchChecklists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.user?.acf.locale]);

  return <></>;
};
